/* import __COLOCATED_TEMPLATE__ from './submenu-sections-section-title.hbs'; */
/* RESPONSIBLE TEAM: team-frontend-tech */
/* === ⚠️ THIS FILE CURRENTLY USES DEPRECATED PATTERNS ⚠️ === */
/* === 🔗 For more information visit https://go.inter.com/ember-best-practices 🔗 */
/* === 🚀 Please consider refactoring & removing some of the comments below when working on this file: 🚀 */
/* eslint-disable ember/no-classic-classes */
/* eslint-disable ember/no-classic-components */
/* eslint-disable @intercom/intercom/require-empty-tagname */
import Component from '@ember/component';
export default Component.extend({
  classNames: ['submenu__sections__section__title', 'flex-none'],
  classNameBindings: [
    'collapseSectionLeftPadding:u__padl__10',
    'collapseSectionRightPadding:o__section-padding-right',
  ],
  attributeBindings: ['data-intercom-target'],
  isSelected: false,

  click() {
    let onClickAction = this.onClick;
    if (typeof onClickAction === 'function') {
      onClickAction();
    }
  },
});
